export function updateCounts(setCharacterCount, setWordCount) {
    return (characters, words) => {
        setCharacterCount(characters);
        setWordCount(words);
    };
}
